import { combineReducers } from "redux";

const generateProductImage = (state = {}, action) => {
    switch (action.type) {
        case "GENERATE_PRODUCT_IMAGE_SUCCESS":
            return {
                isLoading: false,
                isError: false,
                isSuccess: true,
                generatedImage: action.payload.image,
                uuid: action.payload.uuid,
            };
        case "CLEAR_GENERATED_PRODUCT_IMAGE":
            return {};
        default:
            return state;
    }
};

const fetchUserProducts = (state = {}, action) => {
    switch (action.type) {
        case "FETCH_USER_PRODUCTS_SUCCESS":
            state[action.key] = {
                isLoading: false,
                isError: false,
                isSuccess: true,
                searchProducts: action.payload.searchResult,
                searchKey: action.payload.searchKey,
                totalSearchProducts: action.payload.totalSearchResult,
            };
        default:
            return state;
    }
};

export default combineReducers({
    generateProductImage,
    fetchUserProducts,
});
